"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameObjectToJSON = exports.NameObjectFromJSONTyped = exports.NameObjectFromJSON = void 0;
const runtime_1 = require("../runtime");
function NameObjectFromJSON(json) {
    return NameObjectFromJSONTyped(json, false);
}
exports.NameObjectFromJSON = NameObjectFromJSON;
function NameObjectFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'middleName': !runtime_1.exists(json, 'middleName') ? undefined : json['middleName'],
        'noMiddleName': json['noMiddleName'],
        'lastName': json['lastName'],
        'suffix': !runtime_1.exists(json, 'suffix') ? undefined : json['suffix'],
    };
}
exports.NameObjectFromJSONTyped = NameObjectFromJSONTyped;
function NameObjectToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstName': value.firstName,
        'middleName': value.middleName,
        'noMiddleName': value.noMiddleName,
        'lastName': value.lastName,
        'suffix': value.suffix,
    };
}
exports.NameObjectToJSON = NameObjectToJSON;
//# sourceMappingURL=NameObject.js.map